"use strict";

var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TimeoutError =
/*#__PURE__*/
function (_Error) {
  _inherits(TimeoutError, _Error);

  function TimeoutError() {
    _classCallCheck(this, TimeoutError);

    return _possibleConstructorReturn(this, _getPrototypeOf(TimeoutError).apply(this, arguments));
  }

  return TimeoutError;
}(_wrapNativeSuper(Error));

exports.TimeoutError = TimeoutError;